import { lazyModulePage } from '@/soluqr/tiers/lazyModulePage';

export const ordersRouteElements = [
  {
    segment: 'orders/kitchen',
    element: lazyModulePage('orders', () => import('@/soluqr/modules/orders/screens/KitchenScreenPage')),
  },
  {
    segment: 'orders',
    element: lazyModulePage('orders', () => import('@/soluqr/modules/orders/screens/OrdersPage')),
  },
  {
    segment: 'orders-live',
    element: lazyModulePage('orders', () => import('@/soluqr/modules/orders/screens/DashboardOrdersPage')),
  },
  { segment: 'kds', element: lazyModulePage('orders', () => import('@/soluqr/modules/orders/screens/KdsPage')) },
  { segment: 'pos', element: lazyModulePage('orders', () => import('@/soluqr/modules/orders/screens/PosPage')) },
  {
    segment: 'notifications',
    element: lazyModulePage('orders', () => import('@/soluqr/modules/orders/screens/NotificationsPage')),
  },
  { segment: 'tables', element: lazyModulePage('orders', () => import('@/soluqr/modules/orders/screens/TablesPage')) },
];
